import React, { useEffect, useState } from "react";
import PatientLoader from "../../common/PatientLoader";
import { useDispatch, useSelector } from "react-redux";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import { patientLogic } from "../../../store/features/patient/patientSlice";
import CardLayout from "../../common/cardLayout/CardLayout";
import { useNavigate, useParams } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import { Line } from "react-chartjs-2";
import moment from "moment";
import { ReactComponent as ChevronLeftIcon } from "../../../assets/icons/chevron-left.svg";

const PatientMeasure = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, patientData } = useSelector((state) => state.patient);
  const { user } = useSelector((state) => state.app);
  const [showTotalPatient, setShowTotalPatient] = useState(true);
  const currentDate = moment();
  const previousYear = moment(currentDate).subtract(1, "years");
  const firstDayOfPreviousYear = moment(previousYear).startOf("year");
  const [startDate, setStartDate] = useState(
    firstDayOfPreviousYear.format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateRange, setDateRange] = useState([
    new Date(firstDayOfPreviousYear.format("YYYY-MM-DD")),
    new Date(moment().format("YYYY-MM-DD")),
  ]);
  const [labelData, setLabelData] = useState([]);
  const [plotData, setPlotData] = useState([]);
  const [title, setTitle] = useState("");

  const { afterToday } = DateRangePicker;

  const params = useParams();

  useEffect(() => {
    if (params?.type === "total") {
      setShowTotalPatient(true);
      setTitle("Patients on Rose till Date");
    } else {
      setShowTotalPatient(false);
      setTitle("Active patients on Rose");
    }
  }, [params]);
  useEffect(() => {
    dispatch(
      patientLogic({
        page_size: 999999,
        page: 1,
        clinic_id: user?.clinic?.id,
        clinician_id: user?.id,
      })
    );
  }, []);

  const handleDateRangeSelect = (dateRange) => {
    setDateRange(dateRange);
  };
  useEffect(() => {
    setStartDate(moment(dateRange[0]).format("YYYY-MM-DD"));
    setEndDate(moment(dateRange[1]).format("YYYY-MM-DD"));
  }, [dateRange]);

  const processGraphData = () => {
    let breakDownforGraph = [];
    let filteredData = [];
    let graphX = [];
    let graphY = [];
    const fromDate = moment(startDate);
    const toDate = moment(endDate);
    patientData?.forEach((patient) => {
      if (
        showTotalPatient &&
        moment(patient.date_joined).isAfter(fromDate) &&
        moment(patient.date_joined).isBefore(toDate)
      ) {
        breakDownforGraph.push(patient.date_joined);
      }
      if (
        !showTotalPatient &&
        moment(patient.last_active).isAfter(fromDate) &&
        moment(patient.last_active).isBefore(toDate)
      ) {
        breakDownforGraph.push(patient.last_active);
      }
      breakDownforGraph.sort((a, b) => new Date(a) - new Date(b));
      breakDownforGraph.forEach(
        (x, index) => (breakDownforGraph[index] = moment(x).format("MMM YYYY"))
      );
      filteredData = [...new Set([...breakDownforGraph])];

      filteredData.forEach((x, index) => {
        filteredData[index] = { month: x, count: 0 };
      });

      breakDownforGraph.forEach((x) => {
        filteredData.find((ex) => {
          if (ex.month === x) {
            ex.count = ex.count + 1;
            return 1;
          }
          return 0;
        });
      });

      filteredData.forEach((x, index) => {
        graphX[index] = x.month;
        graphY[index] = x.count;
      });
    });
    setLabelData(graphX);
    setPlotData(graphY);
  };
  useEffect(() => {
    processGraphData();
  }, [startDate, endDate, showTotalPatient]);

  useEffect(() => {
    processGraphData();
  }, []);

  const handleNavigation = (navigate_to) => {
    navigate(navigate_to);
  };

  const data = {
    labels: labelData,
    datasets: [
      {
        label: "",
        backgroundColor: "#00008B",
        borderColor: "#00008B",
        data: plotData,
      },
    ],
  };

  const LineChart = () => {
    return (
      <Line
        data={data}
        options={{
          responsive: true,
          plugins: { legend: { display: false } },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,

              type: "linear",

              grid: {
                display: true,
              },
            },
          },
        }}
      />
    );
  };

  return (
    <SidebarLayout>
      <div className="row col-sm-12 col-md-12 col-lg-12 pt-5 pb-2 mt-5">
        <div className="p-4 flex justify-between">
          <button
            style={{ display: "inline" }}
            class="btn"
            title="back to dashboard"
            onClick={() => handleNavigation("/aco/home")}
          >
            <i>
              {" "}
              <ChevronLeftIcon />
            </i>
          </button>
          <h4
            style={{
              textAlign: "left",
              display: "inline-block",
              position: "relative",
            }}
          >
            {title}
          </h4>
        </div>
      </div>
      <div className="row container-fluid px-5 py-2">
        <div className="d-flex container-fluid w-100">
          <DateRangePicker
            placeholder="Select Date Range"
            onChange={handleDateRangeSelect}
            shouldDisableDate={afterToday()}
            value={dateRange}
          />
        </div>
        <CardLayout
          className="col-sm-12 col-md-12 col-lg-12"
          style={{
            border: "8px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
          {loading ? <PatientLoader /> : <LineChart />}
        </CardLayout>
      </div>
    </SidebarLayout>
  );
};

export default PatientMeasure;
